// Sans dayjs : lu aussi par les tests Playwright, hors navigateur.

/**
 * Leçon en cours parmi des leçons (commencée, pas encore finie) ; la plus récemment commencée s'il y
 * en a plusieurs. Résumé de la séance ouvert pendant la séance : elle est choisie d'office (J32).
 */
export function lessonInProgress<T extends { startsAt: string; endsAt: string }>(lessons: T[], now = Date.now()): T | undefined {
  return lessons
    .filter((l) => Date.parse(l.startsAt) <= now && Date.parse(l.endsAt) > now)
    .sort((a, b) => Date.parse(b.startsAt) - Date.parse(a.startsAt))[0];
}
